"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { createProductDefaultDataBinding } from "@/libs/commerce/ProductContent";

import { PRODUCT_SPECIFICATION_INPUTS } from "./ProductSpecification.inputs.builder";

export const ProductSpecificationComponent: RegisteredComponent = {
  name: "ProductSpecification",
  friendlyName: "Product Specification",
  component: dynamic(async () => (await import("./ProductSpecification")).ProductSpecification, { ssr: false }),
  models: [getBuilderModelName("product")],
  defaults: {
    bindings: createProductDefaultDataBinding<typeof PRODUCT_SPECIFICATION_INPUTS>({
      customAttributes: "productCustomAttributes",
    }),
  },
  inputs: PRODUCT_SPECIFICATION_INPUTS,
};
